// src/configs/workerViewConfig.js

import { formatDate, formatDateTime } from '@/utils/dateUtil';
import { ElMessage } from "element-plus";

// 计算年龄的工具函数
const calculateAge = (birthday) => {
    if (!birthday) return '';
    const birthDate = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // 如果生日还没到，年龄减1
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};

export const workerViewConfig = {
    buttons: [
        {
            text: '编辑',
            type: 'primary',
            handler: (context) => {
                if (context.selectedRows.length === 1) {
                    context.formData = { ...context.selectedRows[0] };
                    context.dialogVisible = true;
                } else {
                    ElMessage.warning('请选择一条记录进行编辑');
                }
            },
            disabled: (context) => context.selectedRows.length !== 1
        },
        {
            text: '刷新',
            type: 'primary',
            handler: (context) => {
                context.fetchData(); // 刷新数据
            }
        }
    ],
    columns: [
        { prop: 'name', label: '姓名', width: '80', type: 'string' },
        { prop: 'mobile', label: '手机号', width: '120', type: 'string' },
        { prop: 'idcard', label: '身份证号', width: '180', type: 'string' },
        { prop: 'address', label: '住址', minWidth: '200', type: 'string', customTooltip: true },
        { prop: 'jobType', label: '工种', width: '120', type: 'string' },
        { prop: 'jobYears', label: '工龄', width: '100', type: 'string' },
        // { prop: 'occupation', label: '专业工种', width: '120', type: 'string' }, // 后台备用字段
        {
            prop: 'reviseTime',
            label: '修改时间',
            width: '180',
            type: 'date',
            formatter: (row) => {
                return formatDateTime(row.reviseTime);
            }
        }
    ],
    selectable: true,
    searchPlaceholder: '请输入姓名|手机号|工种',
    dialog: {
        title: '编辑工人信息',
        width: '65%',
        fields: [
            {
                prop: 'name',
                label: '姓名',

                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'gender',
                label: '性别',
                type: 'select',
                options: [
                    { value: '男', label: '男' },
                    { value: '女', label: '女' },
                ],
                required: true,
                span: 12
            },
            {
                prop: 'birthday',
                label: '出生日期',
                width: '120',
                type: 'date',
                formatter: (row) => {
                    return formatDate(row.birthday);
                },
                required: true,
                span: 12
            },


            {
                prop: 'age',
                label: '年龄',
                type: 'input',
                span: 12
            },

            {
                prop: 'idcard',
                label: '身份证',
                width: '120',
                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'address',
                label: '家庭地址',
                width: '120',
                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'mobile',
                label: '联系电话',
                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'occupation',
                label: '专业工种',

                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'grade',
                label: '职业技能',
                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'remuneration',
                label: '薪酬标准',
                width: '60',
                type: 'input',
                required: true,
                span: 12
            },
            {
                prop: 'preferredLocation',
                label: '期望工作地',
                type: 'input',
                required: true,
                span: 12
            },
            // { prop: 'preferredLocation',
            //     label: '用工单位',
            //     type: 'input',
            //     required: true,
            //     span: 12
            // },


        ]
    },
    rules: {
        workerName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
            { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        memberType: [
            { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        major: [
            { required: true, message: '请输入负责人', trigger: 'blur' }
        ]
    },


};

export default workerViewConfig;
